import { onReadyWidgetOfType } from '../utils/helper';

onReadyWidgetOfType("LatestNewsWidget", (widget, data) => {

    const mediaReleasesTab = widget.querySelector("#media-releases-tab");
    const serviceAnnouncementsTab = widget.querySelector("#service-announcements-tab");

    const mediaReleases = widget.querySelector("#media-releases");
    const serviceAnnouncements = widget.querySelector("#service-announcements");

    const urlMediaReleases = widget.dataset.media;
    const urlServiceAnnouncements = widget.dataset.service;

    mediaReleasesTab.addEventListener("click", () => {
        console.log("mediaReleasesTab clicked");
        if (!mediaReleasesTab.classList.contains("latestTabColActive")) {
            serviceAnnouncementsTab.classList.remove("latestTabColActive");
            serviceAnnouncements.classList.remove("d-block", "d-md-grid");
            serviceAnnouncements.classList.add("d-none");

            mediaReleasesTab.classList.add("latestTabColActive");
            mediaReleases.classList.remove("d-none");
            mediaReleases.classList.add("d-block", "d-md-grid");
        }
        const viewMoreButton = getViewMoreButton(urlServiceAnnouncements);
        if (viewMoreButton) {
            viewMoreButton.href = urlMediaReleases;
        }
    });

    serviceAnnouncementsTab.addEventListener("click", () => {
        console.log("serviceAnnouncementsTab clicked");
        if (!serviceAnnouncementsTab.classList.contains("latestTabColActive")) {
            mediaReleasesTab.classList.remove("latestTabColActive");
            mediaReleases.classList.remove("d-block", "d-md-grid");
            mediaReleases.classList.add("d-none");

            serviceAnnouncementsTab.classList.add("latestTabColActive");
            serviceAnnouncements.classList.remove("d-none");
            serviceAnnouncements.classList.add("d-block", "d-md-grid");
        }
        const viewMoreButton = getViewMoreButton(urlMediaReleases);
        if (viewMoreButton) {
            viewMoreButton.href = urlServiceAnnouncements;
        }
    });
});

function getViewMoreButton(target) {
    const viewMoreButtonLatestNews = document.querySelector(`[widget-type="CTAButton"] a[href="${target}"]`);
    console.log({ viewMoreButtonLatestNews })
    return viewMoreButtonLatestNews;
}
